// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__25z4e","title":"Info_title__1w0LP","selects":"Info_selects__1MgyI","requiredAsterisk":"Info_requiredAsterisk__20PhL"};